import { SnackbarType } from 'features/SnackbarManager/types'

export const actions = {
  addSnackbar: (snackbar: Omit<SnackbarType, 'id'>) =>
    ({ type: 'SNACKBAR__ADD_SNACKBAR', snackbar } as const),

  removeSnackbar: (id: string) =>
    ({ type: 'SNACKBAR__REMOVE_SNACKBAR', id } as const)
}
